"use client";

import { isOpenedFromCapacitor, navigateToTenantSelector, signOutNativeSession } from "@/lib/capacitor";
import { useAuthentication } from "@osn/auth";
import React from "react";

export function useLogout() {
  const {
    actions: { signOut },
  } = useAuthentication({});

  return React.useCallback(async function logout() {
    if (isOpenedFromCapacitor()) {
      await signOutNativeSession();
      await signOut();
      navigateToTenantSelector();
      return;
    }

    await signOut();
  }, [signOut]);
}
